import useFacultySurveyToast from "./useFacultySurveyToast";

export default function FacultySurveyMount() {
  useFacultySurveyToast();
  return null;
}
